<template>
  <div>
    <header
      class="bg-blue-500 py-2 animate__animated animate__fadeInDown animate__faster w-full shadow"
      style="position:fixed;z-index:10;"
    >
      <div class="flex items-center">
        <div class="text-left">
          <button class="button bg-transparent text-white" @click="onBackClicked()">
            <span class="icon">
              <i class="fal fa-chevron-left"></i>
            </span>
          </button>
        </div>
        <div class="flex-1 text-left text-white">
          <slot></slot>
        </div>
      </div>
    </header>
    <div style="clear:both;height:56px;"></div>
  </div>
</template>

<script>
export default {
  name: "app-header",
  methods: {
    onBackClicked() {
      this.$emit("click");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/app-header.vue